import { Buffer3384y49aj0pxr as Buffer } from './Buffer.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var RealBufferedSinkClass;
function RealBufferedSink() {
  if (RealBufferedSinkClass === VOID) {
    class $ {
      constructor(sink) {
        this.o41_1 = sink;
        this.p41_1 = false;
        this.q41_1 = new (Buffer())();
      }
      i3w(source, byteCount) {
        // Inline function 'okio.internal.commonWrite' call
        // Inline function 'kotlin.check' call
        if (!!this.p41_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.q41_1.i3w(source, byteCount);
        this.r41();
        return Unit_instance;
      }
      s40(byteString) {
        // Inline function 'okio.internal.commonWrite' call
        // Inline function 'kotlin.check' call
        if (!!this.p41_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.q41_1.s40(byteString);
        return this.r41();
      }
      u40(string) {
        // Inline function 'okio.internal.commonWriteUtf8' call
        // Inline function 'kotlin.check' call
        if (!!this.p41_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.q41_1.u40(string);
        return this.r41();
      }
      v40(string, beginIndex, endIndex) {
        // Inline function 'okio.internal.commonWriteUtf8' call
        // Inline function 'kotlin.check' call
        if (!!this.p41_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.q41_1.v40(string, beginIndex, endIndex);
        return this.r41();
      }
      w40(b) {
        // Inline function 'okio.internal.commonWriteByte' call
        // Inline function 'kotlin.check' call
        if (!!this.p41_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.q41_1.w40(b);
        return this.r41();
      }
      r41() {
        // Inline function 'okio.internal.commonEmitCompleteSegments' call
        // Inline function 'kotlin.check' call
        if (!!this.p41_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        var byteCount = this.q41_1.d40();
        if (byteCount > 0n) {
          this.o41_1.i3w(this.q41_1, byteCount);
        }
        return this;
      }
      oc() {
        // Inline function 'okio.internal.commonFlush' call
        // Inline function 'kotlin.check' call
        if (!!this.p41_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        if (this.q41_1.k3w_1 > 0n) {
          this.o41_1.i3w(this.q41_1, this.q41_1.k3w_1);
        }
        this.o41_1.oc();
        return Unit_instance;
      }
      l6() {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonClose' call
          if (this.p41_1) {
            tmp$ret$0 = Unit_instance;
            break $l$block;
          }
          var thrown = null;
          try {
            if (this.q41_1.k3w_1 > 0n) {
              this.o41_1.i3w(this.q41_1, this.q41_1.k3w_1);
            }
          } catch ($p) {
            if ($p instanceof Error) {
              var e = $p;
              thrown = e;
            } else {
              throw $p;
            }
          }
          try {
            this.o41_1.l6();
          } catch ($p) {
            if ($p instanceof Error) {
              var e_0 = $p;
              if (thrown == null)
                thrown = e_0;
            } else {
              throw $p;
            }
          }
          this.p41_1 = true;
          if (!(thrown == null))
            throw thrown;
          tmp$ret$0 = Unit_instance;
        }
        return tmp$ret$0;
      }
      toString() {
        // Inline function 'okio.internal.commonToString' call
        return 'buffer(' + toString(this.o41_1) + ')';
      }
    }
    initMetadataForClass($, 'RealBufferedSink');
    RealBufferedSinkClass = $;
  }
  return RealBufferedSinkClass;
}
//region block: exports
export {
  RealBufferedSink as RealBufferedSinkipqv3pv5gqfq,
};
//endregion

//# sourceMappingURL=RealBufferedSink.mjs.map
